var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('router-link',{attrs:{"to":"/"}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('UserLayout',{staticClass:"user-layout",nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }